/**
 * Textes de la zone « Personnes » (clés préfixées `people.`), fusionnés dans les dictionnaires par i18n/locales/*.ts.
 * Les trois langues doivent fournir exactement les mêmes clés et variables (vérifié par les tests i18n).
 */
export const peopleFr = {
  'people.title': 'Personnes et accès',
  'people.description': 'Utilisateurs, rôles, invitations et sécurité des connexions.',
  'people.tabs': 'Sections des personnes',
  'people.tab.users': 'Utilisateurs',
  'people.tab.roles': 'Rôles',
  'people.tab.invitations': 'Invitations',
  'people.tab.security': 'Sécurité',
  'people.cancel': 'Annuler',
  'people.save': 'Enregistrer',
  'people.readOnly': 'Vous n\'avez pas le droit de modifier ces réglages.',

  'people.error.generic': 'L\'action a échoué. Réessayez.',
  'people.error.last_owner': 'Il doit toujours rester au moins un propriétaire actif.',
  'people.error.system_role': 'Les rôles prédéfinis ne peuvent pas être modifiés.',
  'people.error.role_in_use': 'Ce rôle est encore attribué à des utilisateurs.',
  'people.error.already_member': 'Cette personne fait déjà partie de l\'organisation.',
  'people.error.already_invited': 'Une invitation est déjà en attente pour cette adresse.',
  'people.error.forbidden': 'Votre rôle ne permet pas cette action.',

  'people.status.active': 'Actif',
  'people.status.suspended': 'Suspendu',
  'people.status.invited': 'Invité',
  'people.invitation.pending': 'En attente',
  'people.invitation.accepted': 'Acceptée',
  'people.invitation.expired': 'Expirée',
  'people.invitation.revoked': 'Révoquée',

  'people.users.table': 'Utilisateurs de l\'organisation',
  'people.users.filters': 'Filtres des utilisateurs',
  'people.users.search': 'Rechercher un nom ou une adresse e-mail',
  'people.users.allRoles': 'Tous les rôles',
  'people.users.allStatus': 'Tous les statuts',
  'people.users.empty': 'Aucun utilisateur ne correspond',
  'people.users.col.user': 'Utilisateur',
  'people.users.col.role': 'Rôle',
  'people.users.col.groups': 'Groupes',
  'people.users.col.status': 'Statut',
  'people.users.col.twofa': '2FA',
  'people.users.col.lastSeen': 'Dernière connexion',
  'people.users.col.actions': 'Actions',
  'people.users.allGroups': 'Tous les groupes',
  'people.users.twofaOn': 'Activée',
  'people.users.twofaOff': 'Absente',
  'people.users.never': 'Jamais',
  'people.users.you': 'vous',
  'people.users.actionsFor': 'Actions pour {name}',
  'people.users.edit': 'Modifier rôle et groupes',
  'people.users.suspend': 'Suspendre',
  'people.users.reactivate': 'Réactiver',
  'people.users.remove': 'Retirer de l\'organisation',
  'people.users.suspended': '{name} est suspendu(e)',
  'people.users.reactivated': '{name} est réactivé(e)',
  'people.users.editTitle': 'Modifier {name}',
  'people.users.selfRole': 'Vous ne pouvez pas changer votre propre rôle.',
  'people.users.groupsHint': 'Sans groupe, la personne a accès à tous les groupes que son rôle permet.',
  'people.users.saved': 'Utilisateur mis à jour',
  'people.users.removeTitle': 'Retirer {name} ?',
  'people.users.removeDesc': 'La personne perd immédiatement l\'accès à l\'organisation. Ses sessions passées restent dans le journal d\'audit.',
  'people.users.removeConfirm': 'Retirer',
  'people.users.removed': '{name} a été retiré(e)',

  'people.invite.cta': 'Inviter un technicien',
  'people.invite.title': 'Inviter un technicien',
  'people.invite.desc': 'La personne reçoit un lien valable 7 jours pour créer son compte.',
  'people.invite.email': 'Adresse e-mail',
  'people.invite.emailInvalid': 'Saisissez une adresse e-mail valide.',
  'people.invite.role': 'Rôle',
  'people.invite.groups': 'Groupes d\'appareils',
  'people.invite.groupsHint': 'Facultatif : limite l\'accès aux groupes cochés.',
  'people.invite.send': 'Envoyer l\'invitation',
  'people.invite.sent': 'Invitation envoyée à {email}',

  'people.invitations.table': 'Invitations',
  'people.invitations.view': 'Afficher',
  'people.invitations.view.pending': 'En attente uniquement',
  'people.invitations.view.all': 'Toutes les invitations',
  'people.invitations.empty': 'Aucune invitation',
  'people.invitations.emptyDesc': 'Invitez un technicien pour qu\'il rejoigne l\'organisation.',
  'people.invitations.by': 'Invité par',
  'people.invitations.expires': 'Expiration',
  'people.invitations.resend': 'Renvoyer',
  'people.invitations.resendFor': 'Renvoyer l\'invitation à {email}',
  'people.invitations.resent': 'Invitation renvoyée à {email}',
  'people.invitations.revoke': 'Révoquer',
  'people.invitations.revokeFor': 'Révoquer l\'invitation de {email}',
  'people.invitations.revokeTitle': 'Révoquer l\'invitation de {email} ?',
  'people.invitations.revokeDesc': 'Le lien envoyé ne fonctionnera plus.',
  'people.invitations.revoked': 'Invitation de {email} révoquée',

  'people.roles.intro': 'Les rôles prédéfinis sont en lecture seule. Créez un rôle personnalisé pour ajuster finement les permissions.',
  'people.roles.matrix': 'Matrice des rôles et permissions',
  'people.roles.permission': 'Permission',
  'people.roles.system': 'Prédéfini',
  'people.roles.custom': 'Personnalisé',
  'people.roles.members': '{count} membre(s)',
  'people.roles.create': 'Nouveau rôle',
  'people.roles.createTitle': 'Nouveau rôle personnalisé',
  'people.roles.editTitle': 'Modifier le rôle',
  'people.roles.name': 'Nom du rôle',
  'people.roles.nameRequired': 'Le nom est obligatoire.',
  'people.roles.description': 'Description',
  'people.roles.created': 'Rôle « {name} » créé',
  'people.roles.saved': 'Rôle « {name} » enregistré',
  'people.roles.saveFor': 'Enregistrer les permissions de {name}',
  'people.roles.discardFor': 'Annuler les changements de {name}',
  'people.roles.editFor': 'Renommer {name}',
  'people.roles.deleteFor': 'Supprimer {name}',
  'people.roles.deleteTitle': 'Supprimer le rôle « {name} » ?',
  'people.roles.deleteDesc': 'Cette action est définitive.',
  'people.roles.deleteInUse': '{count} membre(s) ont encore ce rôle : changez leur rôle avant de le supprimer.',
  'people.roles.deleteConfirm': 'Supprimer le rôle',
  'people.roles.deleted': 'Rôle « {name} » supprimé',

  'people.perm.devices.read': 'Voir les appareils',
  'people.perm.devices.manage': 'Gérer les appareils',
  'people.perm.devices.revoke': 'Révoquer des appareils',
  'people.perm.groups.manage': 'Gérer les groupes',
  'people.perm.members.read': 'Voir les utilisateurs',
  'people.perm.members.invite': 'Inviter des utilisateurs',
  'people.perm.members.manage': 'Gérer les utilisateurs',
  'people.perm.roles.manage': 'Gérer les rôles',
  'people.perm.policies.read': 'Voir les politiques',
  'people.perm.policies.manage': 'Gérer les politiques',
  'people.perm.audit.read': 'Consulter le journal d\'audit',
  'people.perm.audit.export': 'Exporter le journal d\'audit',
  'people.perm.sessions.read': 'Voir les sessions',
  'people.perm.sessions.recordings': 'Lire les enregistrements',
  'people.perm.ratings.read': 'Consulter la satisfaction des clients',
  'people.perm.deployment.manage': 'Gérer le déploiement',
  'people.perm.billing.read': 'Voir la facturation',
  'people.perm.billing.manage': 'Gérer la facturation',
  'people.perm.settings.read': 'Voir les paramètres',
  'people.perm.settings.manage': 'Gérer les paramètres',
  'people.perm.integrations.manage': 'Gérer les intégrations',
  'people.perm.apikeys.manage': 'Gérer les clés d\'API',

  'people.security.access': 'Authentification',
  'people.security.accessDesc': 'Règles de connexion appliquées à tous les membres de l\'organisation.',
  'people.security.twofa': 'Imposer la double authentification (2FA)',
  'people.security.twofaDesc': 'Chaque membre devra configurer un code TOTP à sa prochaine connexion.',
  'people.security.twofaOn': 'La 2FA est désormais imposée',
  'people.security.twofaOff': 'La 2FA n\'est plus imposée',
  'people.security.trusted': 'Appareils de confiance uniquement',
  'people.security.trustedDesc': 'Les techniciens ne peuvent se connecter que depuis un poste préalablement approuvé.',
  'people.security.trustedOn': 'Seuls les appareils de confiance sont acceptés',
  'people.security.trustedOff': 'Tous les appareils sont acceptés',

  'people.sso.title': 'Authentification unique (SSO)',
  'people.sso.desc': 'Connectez Entra ID, Google Workspace ou un autre fournisseur SAML 2.0 / OpenID Connect.',
  'people.sso.configured': 'Configuré',
  'people.sso.notConfigured': 'Non configuré',
  'people.sso.provider': 'Fournisseur',
  'people.sso.provider.entra': 'Microsoft Entra ID',
  'people.sso.provider.google': 'Google Workspace',
  'people.sso.provider.custom': 'Autre fournisseur',
  'people.sso.protocol': 'Protocole',
  'people.sso.protocol.oidc': 'OpenID Connect',
  'people.sso.protocol.saml': 'SAML 2.0',
  'people.sso.issuer': 'URL de l\'émetteur (issuer)',
  'people.sso.metadataUrl': 'URL des métadonnées SAML',
  'people.sso.clientId': 'ID client',
  'people.sso.entityId': 'Identifiant d\'entité (Entity ID)',
  'people.sso.clientSecret': 'Secret client',
  'people.sso.secretStored': 'Un secret est déjà enregistré ; laissez vide pour le conserver.',
  'people.sso.domain': 'Domaine de messagerie',
  'people.sso.domainHint': 'Les adresses de ce domaine passent par le SSO.',
  'people.sso.enforce': 'Imposer le SSO',
  'people.sso.enforceDesc': 'Les membres du domaine ne pourront plus se connecter avec un mot de passe.',
  'people.sso.enforceNeedsTest': 'Disponible après un test de connexion réussi.',
  'people.sso.test': 'Tester la connexion',
  'people.sso.test.ok': 'Test réussi : la configuration est cohérente.',
  'people.sso.test.fail.issuer': 'L\'URL doit être une adresse https valide.',
  'people.sso.test.fail.issuerProvider': 'Cette URL ne correspond pas au fournisseur choisi.',
  'people.sso.test.fail.clientId': 'L\'identifiant client est trop court ou absent.',
  'people.sso.test.fail.secret': 'Le secret client est requis pour OpenID Connect.',
  'people.sso.test.fail.domain': 'Le domaine de messagerie est invalide.',
  'people.sso.lastTest': 'Dernier test réussi : {date}',
  'people.sso.simulated': 'Test simulé : il vérifie la cohérence des champs sans contacter le fournisseur.',
  'people.sso.saved': 'Configuration SSO enregistrée',

  'people.scim.title': 'Provisionnement SCIM',
  'people.scim.desc': 'Créez et désactivez automatiquement les comptes depuis votre annuaire.',
  'people.scim.active': 'Actif',
  'people.scim.inactive': 'Inactif',
  'people.scim.enable': 'Activer SCIM 2.0',
  'people.scim.enableDesc': 'Votre annuaire pourra créer, mettre à jour et suspendre les utilisateurs.',
  'people.scim.enabled': 'SCIM activé',
  'people.scim.disabled': 'SCIM désactivé',
  'people.scim.baseUrl': 'URL de base SCIM',
  'people.scim.copy': 'Copier',
  'people.scim.copied': 'URL copiée',
  'people.scim.copyFailed': 'Copie impossible',
  'people.scim.tokenHint': 'Authentifiez-vous avec une clé d\'API créée dans Paramètres.',

  'people.access.title': 'Blocage par pays et par IP',
  'people.access.desc': 'Limitez les connexions à la console et aux sessions selon leur origine.',
  'people.access.countries': 'Pays autorisés',
  'people.access.countriesHint': 'Codes pays à 2 lettres (ex. DZ, FR). Liste vide : tous les pays.',
  'people.access.countriesEmpty': 'Tous les pays sont autorisés',
  'people.access.countryInvalid': 'Entrez un code pays à 2 lettres, par exemple DZ.',
  'people.access.ips': 'Adresses IP bloquées',
  'people.access.ipsHint': 'Adresse IPv4 / IPv6 ou plage CIDR.',
  'people.access.ipsEmpty': 'Aucune adresse bloquée',
  'people.access.ipInvalid': 'Entrez une adresse IP ou une plage CIDR valide.',
  'people.access.add': 'Ajouter',
  'people.access.addTo': 'Ajouter à la liste : {list}',
  'people.access.remove': 'Retirer {item}',
  'people.access.lockoutWarning': 'Vérifiez que votre propre pays figure dans la liste pour ne pas vous verrouiller.',
  'people.access.saved': 'Restrictions enregistrées',
} as const;

type PeopleKey = keyof typeof peopleFr;

export const peopleEn: Record<PeopleKey, string> = {
  'people.title': 'People and access',
  'people.description': 'Users, roles, invitations and sign-in security.',
  'people.tabs': 'People sections',
  'people.tab.users': 'Users',
  'people.tab.roles': 'Roles',
  'people.tab.invitations': 'Invitations',
  'people.tab.security': 'Security',
  'people.cancel': 'Cancel',
  'people.save': 'Save',
  'people.readOnly': 'You are not allowed to change these settings.',

  'people.error.generic': 'The action failed. Try again.',
  'people.error.last_owner': 'At least one active owner must remain.',
  'people.error.system_role': 'Predefined roles cannot be modified.',
  'people.error.role_in_use': 'This role is still assigned to users.',
  'people.error.already_member': 'This person is already part of the organization.',
  'people.error.already_invited': 'An invitation is already pending for this address.',
  'people.error.forbidden': 'Your role does not allow this action.',

  'people.status.active': 'Active',
  'people.status.suspended': 'Suspended',
  'people.status.invited': 'Invited',
  'people.invitation.pending': 'Pending',
  'people.invitation.accepted': 'Accepted',
  'people.invitation.expired': 'Expired',
  'people.invitation.revoked': 'Revoked',

  'people.users.table': 'Organization users',
  'people.users.filters': 'User filters',
  'people.users.search': 'Search a name or email address',
  'people.users.allRoles': 'All roles',
  'people.users.allStatus': 'All statuses',
  'people.users.empty': 'No matching user',
  'people.users.col.user': 'User',
  'people.users.col.role': 'Role',
  'people.users.col.groups': 'Groups',
  'people.users.col.status': 'Status',
  'people.users.col.twofa': '2FA',
  'people.users.col.lastSeen': 'Last sign-in',
  'people.users.col.actions': 'Actions',
  'people.users.allGroups': 'All groups',
  'people.users.twofaOn': 'Enabled',
  'people.users.twofaOff': 'Missing',
  'people.users.never': 'Never',
  'people.users.you': 'you',
  'people.users.actionsFor': 'Actions for {name}',
  'people.users.edit': 'Edit role and groups',
  'people.users.suspend': 'Suspend',
  'people.users.reactivate': 'Reactivate',
  'people.users.remove': 'Remove from organization',
  'people.users.suspended': '{name} is suspended',
  'people.users.reactivated': '{name} is reactivated',
  'people.users.editTitle': 'Edit {name}',
  'people.users.selfRole': 'You cannot change your own role.',
  'people.users.groupsHint': 'With no group, the person can reach every group their role allows.',
  'people.users.saved': 'User updated',
  'people.users.removeTitle': 'Remove {name}?',
  'people.users.removeDesc': 'The person immediately loses access to the organization. Their past sessions remain in the audit log.',
  'people.users.removeConfirm': 'Remove',
  'people.users.removed': '{name} was removed',

  'people.invite.cta': 'Invite a technician',
  'people.invite.title': 'Invite a technician',
  'people.invite.desc': 'The person receives a link valid for 7 days to create their account.',
  'people.invite.email': 'Email address',
  'people.invite.emailInvalid': 'Enter a valid email address.',
  'people.invite.role': 'Role',
  'people.invite.groups': 'Device groups',
  'people.invite.groupsHint': 'Optional: restricts access to the checked groups.',
  'people.invite.send': 'Send invitation',
  'people.invite.sent': 'Invitation sent to {email}',

  'people.invitations.table': 'Invitations',
  'people.invitations.view': 'Show',
  'people.invitations.view.pending': 'Pending only',
  'people.invitations.view.all': 'All invitations',
  'people.invitations.empty': 'No invitations',
  'people.invitations.emptyDesc': 'Invite a technician to join the organization.',
  'people.invitations.by': 'Invited by',
  'people.invitations.expires': 'Expires',
  'people.invitations.resend': 'Resend',
  'people.invitations.resendFor': 'Resend the invitation to {email}',
  'people.invitations.resent': 'Invitation resent to {email}',
  'people.invitations.revoke': 'Revoke',
  'people.invitations.revokeFor': 'Revoke the invitation of {email}',
  'people.invitations.revokeTitle': 'Revoke the invitation of {email}?',
  'people.invitations.revokeDesc': 'The link that was sent will stop working.',
  'people.invitations.revoked': 'Invitation of {email} revoked',

  'people.roles.intro': 'Predefined roles are read-only. Create a custom role to fine-tune permissions.',
  'people.roles.matrix': 'Role and permission matrix',
  'people.roles.permission': 'Permission',
  'people.roles.system': 'Predefined',
  'people.roles.custom': 'Custom',
  'people.roles.members': '{count} member(s)',
  'people.roles.create': 'New role',
  'people.roles.createTitle': 'New custom role',
  'people.roles.editTitle': 'Edit role',
  'people.roles.name': 'Role name',
  'people.roles.nameRequired': 'The name is required.',
  'people.roles.description': 'Description',
  'people.roles.created': 'Role "{name}" created',
  'people.roles.saved': 'Role "{name}" saved',
  'people.roles.saveFor': 'Save permissions of {name}',
  'people.roles.discardFor': 'Discard changes of {name}',
  'people.roles.editFor': 'Rename {name}',
  'people.roles.deleteFor': 'Delete {name}',
  'people.roles.deleteTitle': 'Delete role "{name}"?',
  'people.roles.deleteDesc': 'This action is permanent.',
  'people.roles.deleteInUse': '{count} member(s) still have this role: change their role before deleting it.',
  'people.roles.deleteConfirm': 'Delete role',
  'people.roles.deleted': 'Role "{name}" deleted',

  'people.perm.devices.read': 'View devices',
  'people.perm.devices.manage': 'Manage devices',
  'people.perm.devices.revoke': 'Revoke devices',
  'people.perm.groups.manage': 'Manage groups',
  'people.perm.members.read': 'View users',
  'people.perm.members.invite': 'Invite users',
  'people.perm.members.manage': 'Manage users',
  'people.perm.roles.manage': 'Manage roles',
  'people.perm.policies.read': 'View policies',
  'people.perm.policies.manage': 'Manage policies',
  'people.perm.audit.read': 'View the audit log',
  'people.perm.audit.export': 'Export the audit log',
  'people.perm.sessions.read': 'View sessions',
  'people.perm.sessions.recordings': 'Play recordings',
  'people.perm.ratings.read': 'View customer satisfaction',
  'people.perm.deployment.manage': 'Manage deployment',
  'people.perm.billing.read': 'View billing',
  'people.perm.billing.manage': 'Manage billing',
  'people.perm.settings.read': 'View settings',
  'people.perm.settings.manage': 'Manage settings',
  'people.perm.integrations.manage': 'Manage integrations',
  'people.perm.apikeys.manage': 'Manage API keys',

  'people.security.access': 'Authentication',
  'people.security.accessDesc': 'Sign-in rules applied to every member of the organization.',
  'people.security.twofa': 'Require two-factor authentication (2FA)',
  'people.security.twofaDesc': 'Every member will have to set up a TOTP code at their next sign-in.',
  'people.security.twofaOn': '2FA is now required',
  'people.security.twofaOff': '2FA is no longer required',
  'people.security.trusted': 'Trusted devices only',
  'people.security.trustedDesc': 'Technicians can only sign in from a previously approved workstation.',
  'people.security.trustedOn': 'Only trusted devices are accepted',
  'people.security.trustedOff': 'All devices are accepted',

  'people.sso.title': 'Single sign-on (SSO)',
  'people.sso.desc': 'Connect Entra ID, Google Workspace or another SAML 2.0 / OpenID Connect provider.',
  'people.sso.configured': 'Configured',
  'people.sso.notConfigured': 'Not configured',
  'people.sso.provider': 'Provider',
  'people.sso.provider.entra': 'Microsoft Entra ID',
  'people.sso.provider.google': 'Google Workspace',
  'people.sso.provider.custom': 'Other provider',
  'people.sso.protocol': 'Protocol',
  'people.sso.protocol.oidc': 'OpenID Connect',
  'people.sso.protocol.saml': 'SAML 2.0',
  'people.sso.issuer': 'Issuer URL',
  'people.sso.metadataUrl': 'SAML metadata URL',
  'people.sso.clientId': 'Client ID',
  'people.sso.entityId': 'Entity ID',
  'people.sso.clientSecret': 'Client secret',
  'people.sso.secretStored': 'A secret is already stored; leave empty to keep it.',
  'people.sso.domain': 'Email domain',
  'people.sso.domainHint': 'Addresses from this domain go through SSO.',
  'people.sso.enforce': 'Enforce SSO',
  'people.sso.enforceDesc': 'Members of the domain will no longer be able to sign in with a password.',
  'people.sso.enforceNeedsTest': 'Available after a successful connection test.',
  'people.sso.test': 'Test connection',
  'people.sso.test.ok': 'Test passed: the configuration is consistent.',
  'people.sso.test.fail.issuer': 'The URL must be a valid https address.',
  'people.sso.test.fail.issuerProvider': 'This URL does not match the selected provider.',
  'people.sso.test.fail.clientId': 'The client ID is missing or too short.',
  'people.sso.test.fail.secret': 'The client secret is required for OpenID Connect.',
  'people.sso.test.fail.domain': 'The email domain is invalid.',
  'people.sso.lastTest': 'Last successful test: {date}',
  'people.sso.simulated': 'Simulated test: it checks field consistency without contacting the provider.',
  'people.sso.saved': 'SSO configuration saved',

  'people.scim.title': 'SCIM provisioning',
  'people.scim.desc': 'Automatically create and deactivate accounts from your directory.',
  'people.scim.active': 'Active',
  'people.scim.inactive': 'Inactive',
  'people.scim.enable': 'Enable SCIM 2.0',
  'people.scim.enableDesc': 'Your directory will be able to create, update and suspend users.',
  'people.scim.enabled': 'SCIM enabled',
  'people.scim.disabled': 'SCIM disabled',
  'people.scim.baseUrl': 'SCIM base URL',
  'people.scim.copy': 'Copy',
  'people.scim.copied': 'URL copied',
  'people.scim.copyFailed': 'Copy failed',
  'people.scim.tokenHint': 'Authenticate with an API key created in Settings.',

  'people.access.title': 'Country and IP blocking',
  'people.access.desc': 'Restrict console sign-ins and sessions by origin.',
  'people.access.countries': 'Allowed countries',
  'people.access.countriesHint': '2-letter country codes (e.g. DZ, FR). Empty list: all countries.',
  'people.access.countriesEmpty': 'All countries are allowed',
  'people.access.countryInvalid': 'Enter a 2-letter country code, for example DZ.',
  'people.access.ips': 'Blocked IP addresses',
  'people.access.ipsHint': 'IPv4 / IPv6 address or CIDR range.',
  'people.access.ipsEmpty': 'No blocked address',
  'people.access.ipInvalid': 'Enter a valid IP address or CIDR range.',
  'people.access.add': 'Add',
  'people.access.addTo': 'Add to the list: {list}',
  'people.access.remove': 'Remove {item}',
  'people.access.lockoutWarning': 'Make sure your own country is in the list so you do not lock yourself out.',
  'people.access.saved': 'Restrictions saved',
};

export const peopleAr: Record<PeopleKey, string> = {
  'people.title': 'الأشخاص والوصول',
  'people.description': 'المستخدمون والأدوار والدعوات وأمان تسجيل الدخول.',
  'people.tabs': 'أقسام الأشخاص',
  'people.tab.users': 'المستخدمون',
  'people.tab.roles': 'الأدوار',
  'people.tab.invitations': 'الدعوات',
  'people.tab.security': 'الأمان',
  'people.cancel': 'إلغاء',
  'people.save': 'حفظ',
  'people.readOnly': 'ليست لديك صلاحية تعديل هذه الإعدادات.',

  'people.error.generic': 'فشل الإجراء. حاول مرة أخرى.',
  'people.error.last_owner': 'يجب أن يبقى مالك نشط واحد على الأقل.',
  'people.error.system_role': 'لا يمكن تعديل الأدوار المعرّفة مسبقًا.',
  'people.error.role_in_use': 'لا يزال هذا الدور مسندًا إلى مستخدمين.',
  'people.error.already_member': 'هذا الشخص عضو في المؤسسة بالفعل.',
  'people.error.already_invited': 'توجد دعوة قيد الانتظار لهذا العنوان.',
  'people.error.forbidden': 'دورك لا يسمح بهذا الإجراء.',

  'people.status.active': 'نشط',
  'people.status.suspended': 'موقوف',
  'people.status.invited': 'مدعو',
  'people.invitation.pending': 'قيد الانتظار',
  'people.invitation.accepted': 'مقبولة',
  'people.invitation.expired': 'منتهية',
  'people.invitation.revoked': 'ملغاة',

  'people.users.table': 'مستخدمو المؤسسة',
  'people.users.filters': 'عوامل تصفية المستخدمين',
  'people.users.search': 'ابحث عن اسم أو بريد إلكتروني',
  'people.users.allRoles': 'كل الأدوار',
  'people.users.allStatus': 'كل الحالات',
  'people.users.empty': 'لا يوجد مستخدم مطابق',
  'people.users.col.user': 'المستخدم',
  'people.users.col.role': 'الدور',
  'people.users.col.groups': 'المجموعات',
  'people.users.col.status': 'الحالة',
  'people.users.col.twofa': 'المصادقة الثنائية',
  'people.users.col.lastSeen': 'آخر تسجيل دخول',
  'people.users.col.actions': 'إجراءات',
  'people.users.allGroups': 'كل المجموعات',
  'people.users.twofaOn': 'مفعّلة',
  'people.users.twofaOff': 'غير مفعّلة',
  'people.users.never': 'أبدًا',
  'people.users.you': 'أنت',
  'people.users.actionsFor': 'إجراءات خاصة بـ {name}',
  'people.users.edit': 'تعديل الدور والمجموعات',
  'people.users.suspend': 'إيقاف',
  'people.users.reactivate': 'إعادة التفعيل',
  'people.users.remove': 'إزالة من المؤسسة',
  'people.users.suspended': 'تم إيقاف {name}',
  'people.users.reactivated': 'تمت إعادة تفعيل {name}',
  'people.users.editTitle': 'تعديل {name}',
  'people.users.selfRole': 'لا يمكنك تغيير دورك بنفسك.',
  'people.users.groupsHint': 'بدون مجموعة، يصل الشخص إلى كل المجموعات التي يسمح بها دوره.',
  'people.users.saved': 'تم تحديث المستخدم',
  'people.users.removeTitle': 'إزالة {name}؟',
  'people.users.removeDesc': 'يفقد الشخص فورًا الوصول إلى المؤسسة. تبقى جلساته السابقة في سجل التدقيق.',
  'people.users.removeConfirm': 'إزالة',
  'people.users.removed': 'تمت إزالة {name}',

  'people.invite.cta': 'دعوة تقني',
  'people.invite.title': 'دعوة تقني',
  'people.invite.desc': 'يتلقى الشخص رابطًا صالحًا لمدة 7 أيام لإنشاء حسابه.',
  'people.invite.email': 'البريد الإلكتروني',
  'people.invite.emailInvalid': 'أدخل بريدًا إلكترونيًا صالحًا.',
  'people.invite.role': 'الدور',
  'people.invite.groups': 'مجموعات الأجهزة',
  'people.invite.groupsHint': 'اختياري: يقيّد الوصول إلى المجموعات المحددة.',
  'people.invite.send': 'إرسال الدعوة',
  'people.invite.sent': 'تم إرسال الدعوة إلى {email}',

  'people.invitations.table': 'الدعوات',
  'people.invitations.view': 'عرض',
  'people.invitations.view.pending': 'قيد الانتظار فقط',
  'people.invitations.view.all': 'جميع الدعوات',
  'people.invitations.empty': 'لا توجد دعوات',
  'people.invitations.emptyDesc': 'ادعُ تقنيًا للانضمام إلى المؤسسة.',
  'people.invitations.by': 'دعاه',
  'people.invitations.expires': 'الانتهاء',
  'people.invitations.resend': 'إعادة الإرسال',
  'people.invitations.resendFor': 'إعادة إرسال الدعوة إلى {email}',
  'people.invitations.resent': 'تمت إعادة إرسال الدعوة إلى {email}',
  'people.invitations.revoke': 'إلغاء',
  'people.invitations.revokeFor': 'إلغاء دعوة {email}',
  'people.invitations.revokeTitle': 'إلغاء دعوة {email}؟',
  'people.invitations.revokeDesc': 'سيتوقف الرابط المرسل عن العمل.',
  'people.invitations.revoked': 'تم إلغاء دعوة {email}',

  'people.roles.intro': 'الأدوار المعرّفة مسبقًا للقراءة فقط. أنشئ دورًا مخصصًا لضبط الصلاحيات بدقة.',
  'people.roles.matrix': 'مصفوفة الأدوار والصلاحيات',
  'people.roles.permission': 'الصلاحية',
  'people.roles.system': 'معرّف مسبقًا',
  'people.roles.custom': 'مخصص',
  'people.roles.members': '{count} عضو',
  'people.roles.create': 'دور جديد',
  'people.roles.createTitle': 'دور مخصص جديد',
  'people.roles.editTitle': 'تعديل الدور',
  'people.roles.name': 'اسم الدور',
  'people.roles.nameRequired': 'الاسم مطلوب.',
  'people.roles.description': 'الوصف',
  'people.roles.created': 'تم إنشاء الدور «{name}»',
  'people.roles.saved': 'تم حفظ الدور «{name}»',
  'people.roles.saveFor': 'حفظ صلاحيات {name}',
  'people.roles.discardFor': 'تجاهل تغييرات {name}',
  'people.roles.editFor': 'إعادة تسمية {name}',
  'people.roles.deleteFor': 'حذف {name}',
  'people.roles.deleteTitle': 'حذف الدور «{name}»؟',
  'people.roles.deleteDesc': 'هذا الإجراء نهائي.',
  'people.roles.deleteInUse': 'لا يزال {count} عضو يحملون هذا الدور: غيّر أدوارهم قبل حذفه.',
  'people.roles.deleteConfirm': 'حذف الدور',
  'people.roles.deleted': 'تم حذف الدور «{name}»',

  'people.perm.devices.read': 'عرض الأجهزة',
  'people.perm.devices.manage': 'إدارة الأجهزة',
  'people.perm.devices.revoke': 'إبطال الأجهزة',
  'people.perm.groups.manage': 'إدارة المجموعات',
  'people.perm.members.read': 'عرض المستخدمين',
  'people.perm.members.invite': 'دعوة المستخدمين',
  'people.perm.members.manage': 'إدارة المستخدمين',
  'people.perm.roles.manage': 'إدارة الأدوار',
  'people.perm.policies.read': 'عرض السياسات',
  'people.perm.policies.manage': 'إدارة السياسات',
  'people.perm.audit.read': 'الاطلاع على سجل التدقيق',
  'people.perm.audit.export': 'تصدير سجل التدقيق',
  'people.perm.sessions.read': 'عرض الجلسات',
  'people.perm.sessions.recordings': 'تشغيل التسجيلات',
  'people.perm.ratings.read': 'الاطلاع على رضا العملاء',
  'people.perm.deployment.manage': 'إدارة النشر',
  'people.perm.billing.read': 'عرض الفوترة',
  'people.perm.billing.manage': 'إدارة الفوترة',
  'people.perm.settings.read': 'عرض الإعدادات',
  'people.perm.settings.manage': 'إدارة الإعدادات',
  'people.perm.integrations.manage': 'إدارة التكاملات',
  'people.perm.apikeys.manage': 'إدارة مفاتيح API',

  'people.security.access': 'المصادقة',
  'people.security.accessDesc': 'قواعد تسجيل الدخول المطبقة على كل أعضاء المؤسسة.',
  'people.security.twofa': 'فرض المصادقة الثنائية (2FA)',
  'people.security.twofaDesc': 'سيتعين على كل عضو إعداد رمز TOTP عند تسجيل دخوله التالي.',
  'people.security.twofaOn': 'أصبحت المصادقة الثنائية إلزامية',
  'people.security.twofaOff': 'لم تعد المصادقة الثنائية إلزامية',
  'people.security.trusted': 'الأجهزة الموثوقة فقط',
  'people.security.trustedDesc': 'لا يستطيع التقنيون تسجيل الدخول إلا من محطة عمل معتمدة مسبقًا.',
  'people.security.trustedOn': 'تُقبل الأجهزة الموثوقة فقط',
  'people.security.trustedOff': 'تُقبل كل الأجهزة',

  'people.sso.title': 'تسجيل الدخول الموحّد (SSO)',
  'people.sso.desc': 'اربط Entra ID أو Google Workspace أو أي مزوّد آخر يدعم SAML 2.0 / OpenID Connect.',
  'people.sso.configured': 'مُعدّ',
  'people.sso.notConfigured': 'غير مُعدّ',
  'people.sso.provider': 'المزوّد',
  'people.sso.provider.entra': 'Microsoft Entra ID',
  'people.sso.provider.google': 'Google Workspace',
  'people.sso.provider.custom': 'مزوّد آخر',
  'people.sso.protocol': 'البروتوكول',
  'people.sso.protocol.oidc': 'OpenID Connect',
  'people.sso.protocol.saml': 'SAML 2.0',
  'people.sso.issuer': 'عنوان المُصدِر (issuer)',
  'people.sso.metadataUrl': 'عنوان بيانات SAML الوصفية',
  'people.sso.clientId': 'معرّف العميل',
  'people.sso.entityId': 'معرّف الكيان (Entity ID)',
  'people.sso.clientSecret': 'سرّ العميل',
  'people.sso.secretStored': 'يوجد سرّ محفوظ بالفعل؛ اتركه فارغًا للإبقاء عليه.',
  'people.sso.domain': 'نطاق البريد الإلكتروني',
  'people.sso.domainHint': 'العناوين التابعة لهذا النطاق تمرّ عبر SSO.',
  'people.sso.enforce': 'فرض SSO',
  'people.sso.enforceDesc': 'لن يتمكن أعضاء النطاق من تسجيل الدخول بكلمة مرور.',
  'people.sso.enforceNeedsTest': 'متاح بعد نجاح اختبار الاتصال.',
  'people.sso.test': 'اختبار الاتصال',
  'people.sso.test.ok': 'نجح الاختبار: الإعدادات متسقة.',
  'people.sso.test.fail.issuer': 'يجب أن يكون العنوان https صالحًا.',
  'people.sso.test.fail.issuerProvider': 'هذا العنوان لا يطابق المزوّد المختار.',
  'people.sso.test.fail.clientId': 'معرّف العميل مفقود أو قصير جدًا.',
  'people.sso.test.fail.secret': 'سرّ العميل مطلوب لـ OpenID Connect.',
  'people.sso.test.fail.domain': 'نطاق البريد الإلكتروني غير صالح.',
  'people.sso.lastTest': 'آخر اختبار ناجح: {date}',
  'people.sso.simulated': 'اختبار محاكى: يتحقق من اتساق الحقول دون الاتصال بالمزوّد.',
  'people.sso.saved': 'تم حفظ إعدادات SSO',

  'people.scim.title': 'التزويد عبر SCIM',
  'people.scim.desc': 'أنشئ الحسابات وعطّلها تلقائيًا انطلاقًا من دليلك.',
  'people.scim.active': 'نشط',
  'people.scim.inactive': 'غير نشط',
  'people.scim.enable': 'تفعيل SCIM 2.0',
  'people.scim.enableDesc': 'سيتمكن دليلك من إنشاء المستخدمين وتحديثهم وإيقافهم.',
  'people.scim.enabled': 'تم تفعيل SCIM',
  'people.scim.disabled': 'تم تعطيل SCIM',
  'people.scim.baseUrl': 'عنوان SCIM الأساسي',
  'people.scim.copy': 'نسخ',
  'people.scim.copied': 'تم نسخ العنوان',
  'people.scim.copyFailed': 'تعذّر النسخ',
  'people.scim.tokenHint': 'صادِق بمفتاح API يُنشأ في الإعدادات.',

  'people.access.title': 'الحظر حسب البلد وعنوان IP',
  'people.access.desc': 'قيّد تسجيل الدخول إلى وحدة التحكم والجلسات بحسب المصدر.',
  'people.access.countries': 'البلدان المسموح بها',
  'people.access.countriesHint': 'رموز بلدان من حرفين (مثل DZ، FR). القائمة الفارغة: كل البلدان.',
  'people.access.countriesEmpty': 'كل البلدان مسموح بها',
  'people.access.countryInvalid': 'أدخل رمز بلد من حرفين، مثل DZ.',
  'people.access.ips': 'عناوين IP المحظورة',
  'people.access.ipsHint': 'عنوان IPv4 / IPv6 أو نطاق CIDR.',
  'people.access.ipsEmpty': 'لا توجد عناوين محظورة',
  'people.access.ipInvalid': 'أدخل عنوان IP أو نطاق CIDR صالحًا.',
  'people.access.add': 'إضافة',
  'people.access.addTo': 'إضافة إلى القائمة: {list}',
  'people.access.remove': 'إزالة {item}',
  'people.access.lockoutWarning': 'تأكد من وجود بلدك في القائمة حتى لا تحجب نفسك.',
  'people.access.saved': 'تم حفظ القيود',
};
